<template>
  <div>
    <h4 class="report-module-title">
      {{ $t('Other Reports') }}
    </h4>
    <div class="report-options">
      <el-date-picker v-model="dataRange"
                      :clearable="false"
                      :disabled="isLoading"
                      :start-placeholder="$t('Start Date')"
                      :end-placeholder="$t('End Date')"
                      type="daterange"
                      align="right"
                      unlink-panels
                      format="MMM dd, yyyy" />
      <el-select v-model="report_type">
        <el-option :label="$t('Discard')" value="discard_reason" />
        <el-option v-if="projectHasObjection"
                   :label="$t('Objection')"
                   value="objection" />
      </el-select>
      <el-button type="primary"
                 :disabled="isLoading"
                 :loading="isLoading"
                 @click="download">
        {{ $t('Apply') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import FileSaver from 'file-saver';
import { chain, kebabCase } from 'lodash';
import { mapState } from 'vuex';
import { Message } from 'element-ui';
import errorResolver from '@/helpers/errorResolver';
import { downloadOtherReports } from './api';

export default {
  name: 'OtherReports',
  props: {
    projectId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      loadingText: '',
      report_type: 'discard_reason',
      dataRange: [new Date(), new Date()]
    };
  },
  computed: {
    ...mapState(['Project']),
    projectHasObjection() {
      return chain(this.Project).has('active.data.objectionable.extra_names').value();
    }
  },
  methods: {
    getNameSuggestion() {
      return this.$prompt(this.$t('Please input a file name or use this suggestion'), this.$t('File name'), {
        confirmButtonText: this.$t('Export'),
        cancelButtonText: this.$t('Cancel'),
        inputValue: kebabCase(`${this.report_type}-report-${new Date().toLocaleTimeString()}`)
      });
    },
    download() {
      this.getNameSuggestion()
        .then(async ({ value }) => {
          const [started_at, ended_at] = this.dataRange;
          this.isLoading = true;

          try {
            const params = {
              report_type: this.report_type,
              started_at,
              ended_at
            };

            const { data } = await downloadOtherReports(this.projectId, params);

            const file = new File([data], `${value}.csv`, {
              type: 'text/plain;charset=utf-8'
            });

            FileSaver.saveAs(file);
          } catch (error) {
            const { message } = errorResolver(error);
            Message({
              type: 'error',
              title: 'Error',
              message
            });
          }
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.report-options {
  margin-top: 10px;

  .el-select {
    margin: 0 10px;
  }
}
</style>
